// Globals
import { TFunction, useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

// Components
import { ITab } from '@/ui';
import GeneralSettingsContainer from '../GeneralSettingsContainer/GeneralSettingsContainer';
import PricesContainer from '../PricesContainer/PricesContainer';
import { StyledPage, StyledPageTitle, StyledTabs } from './SettingsContainerStyles';

// Modules
import { DocumentsSettingsContainer } from '@/modules/DocumentsSettings';

// Helpers
import { SettingsTabs } from '../../helpers';

const getSettingsTabsConfig = (t: TFunction) =>
  [
    {
      label: t('tabs_general'),
      key: SettingsTabs.GENERAL,
      children: <GeneralSettingsContainer />,
    },
    {
      label: t('tabs_prices'),
      key: SettingsTabs.PRICES,
      children: <PricesContainer />,
    },
    {
      label: t('tabs_documents'),
      key: SettingsTabs.DOCUMENTS,
      children: <DocumentsSettingsContainer />,
    },
    {
      label: t('tabs_additional_services'),
      key: SettingsTabs.ADDITIONAL_SERVICES,
    },
    {
      label: t('tabs_steps'),
      key: SettingsTabs.STEPS,
    },
  ] as ITab[];

const SettingsContainer = () => {
  const { t } = useTranslation('settings');
  const [searchParams, setSearchParams] = useSearchParams({
    tab: SettingsTabs.GENERAL,
  });

  return (
    <StyledPage>
      <StyledPageTitle>{t('page_title')}</StyledPageTitle>

      <StyledTabs
        items={getSettingsTabsConfig(t)}
        activeKey={searchParams.get('tab') ?? undefined}
        onChange={(key) => setSearchParams({ tab: key })}
      />
    </StyledPage>
  );
};

export default SettingsContainer;
